import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVectorAnchorPointStraight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVectorAnchorPointStraight"><Path d="M12 4C14.2091 4 16 5.79086 16 8C16 8.74175 15.7971 9.43577 15.4453 10.0312L22.4141 17L21 18.4141L14.0312 11.4453C13.4358 11.7971 12.7417 12 12 12C11.258 12 10.5634 11.7974 9.96777 11.4453L3 18.4141L1.58594 17L8.55371 10.0312C8.20203 9.43587 8 8.74157 8 8C8 5.79086 9.79086 4 12 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVectorAnchorPointStraight;
